import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/fontawesome-free-solid'

const Sort = ({ name, order }) => {
  if (!order) return <i className="fa fa-sort mg-l-4 tx-14"/>
  const orders = order.split(',')
  return name === orders[0] ? orders[1] === 'ASC' ?
    <FontAwesomeIcon icon={faAngleUp} className="mg-l-4 tx-14"/> : <FontAwesomeIcon icon={faAngleDown} className="mg-l-4 tx-14"/> : <i className="fa fa-sort mg-l-4 tx-14"/>
}

export default Sort


// WEBPACK FOOTER //
// ./src/components/Sort.js